<template>
    <v-container fluid grid-list-md>
      <v-layout>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="getBookings"
            :search="search"
            sort-by="id"
            class="elevation-1"
          >
            <template v-slot:item.title_eng ="{ item }">
              <p>{{ item.name }}</p>
            </template>
            <template v-slot:item.email ="{ item }">
              <p>{{ item.email }}</p>
            </template>
            <template v-slot:item.phone ="{ item }">
              <p>{{ item.phone }}</p>
            </template>
            <template v-slot:item.reg_number ="{ item }">
              <p>{{ item.reg_number }}</p>
            </template>
            <template v-slot:item.date_time ="{ item }">
              <p>{{ item.date_time | clearDate }}</p>
            </template>
            <template v-slot:item.status ="{ item }">
              <p>{{ getName(item.status, bookingStatuses) }}</p>
            </template>
            <template v-slot:item.service_type ="{ item }">
              <p>{{ getName(item.service_type, serviceTypes) }}</p>
            </template>
            <template v-slot:item.created ="{ item }">
              <p>{{ item.created | clearDate }}</p>
            </template>
            <template v-slot:item.updated ="{ item }">
              <p>{{ item.updated | clearDate }}</p>
            </template>
            <template v-slot:top>
              <v-toolbar
                flat
              >
                <v-toolbar-title>Bookings</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                 <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog persistent
                  v-model="dialog"
                  max-width="30%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      New booking
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
  
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col>
                            <v-select
                              v-model="editedItem.service_type"
                              :items="serviceTypes"
                              item-text="name"
                              item-value="id"
                              label="Service type"
                              required
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-select
                              v-model="editedItem.status"
                              :items="bookingStatuses"
                              item-text="name"
                              item-value="id"
                              label="Status"
                              required
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="editedItem.name"
                              label="Name"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="editedItem.email"
                              label="Email"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="editedItem.phone"
                              label="Phone"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="editedItem.reg_number"
                              label="Registration number"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              v-model="dateMenu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="pickedDate"
                                  label="Date"
                                  readonly
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                  @click:clear="pickedDate = ''"
                                />
                              </template>
                              <v-date-picker
                                v-model="pickedDate"
                                @input="dateMenu = false"
                              />
                            </v-menu>
                          </v-col>

                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              v-model="timeMenu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="pickedTime"
                                  label="Time"
                                  readonly
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                  @click:clear="pickedTime = ''"
                                />
                              </template>
                              <v-time-picker
                                v-model="pickedTime"
                                format="24hr"
                                @input="timeMenu = false"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.date_time"
                              label="date_time (RFC3339)"
                              readonly
                              :loading="checkBusyLoading"
                            />
                          </v-col>
                        </v-row>

                        <v-row v-if="checkBusyMessage">
                          <v-col cols="12">
                            <v-alert
                              dense
                              text
                              :type="checkBusyAlertType"
                            >
                              {{ checkBusyMessage }}
                            </v-alert>
                          </v-col>
                        </v-row>
                        
                      </v-container>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="headline">Delete this booking?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'bookings',
    components: {
    },
    computed: {
      getBookings () {
        return this.$store.state.Bookings.list === null ? [] : this.$store.state.Bookings.list;
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New booking' : 'Edit booking'
      },
      checkBusyMessage () {
        if (this.checkBusyLoading) return 'Checking availability...'
        if (this.checkBusyError) {
          return `Error checking: ${typeof this.checkBusyError === 'string' ? this.checkBusyError : JSON.stringify(this.checkBusyError)}`
        }
        if (this.checkBusyResponse === null || this.checkBusyResponse === undefined) return ''
        const r = this.checkBusyResponse
        const busy = r === true || r?.busy === true || r?.is_busy === true || r?.isBusy === true
        return busy ? 'This time is available' : 'This time is busy'
      },
      checkBusyAlertType () {
        const r = this.checkBusyResponse
        const busy = r === true || r?.busy === true || r?.is_busy === true || r?.isBusy === true
        if (this.checkBusyError) return 'error'
        return busy ? 'success' : 'warning'
      }
    },
    data () {
      return {
        dialog: false,
        dialogDelete: false,
        search: '',
        dateMenu: false,
        timeMenu: false,
        pickedDate: '',
        pickedTime: '',
        checkBusyLoading: false,
        checkBusyResponse: null,
        checkBusyError: null,
        headers: [
          { text: 'Status', value: 'status', sortable: true },
          { text: 'Service type', value: 'service_type', sortable: true },  
          { text: 'Date and time', value: 'date_time', sortable: true },
          { text: 'Name', value: 'name', sortable: true },
          { text: 'Email', value: 'email', sortable: true },
          { text: 'Phone', value: 'phone', sortable: true },
          { text: 'Registration number', value: 'reg_number', sortable: true },
          { text: 'Created', value: 'created', sortable: true },
          { text: 'Updated', value: 'updated', sortable: true },
          { text: 'Actions', value: 'actions', sortable: false }
        ],
        editedIndex: -1,
        serviceTypes: this.$SERVICE_TYPES,
        bookingStatuses: this.$BOOKING_STATUSES,
        editedItem: {
          id: null,
          name: '',
          email: '',
          phone: '',
          reg_number: '',
          date_time: '',
          status: null,
          service_type: null,
        },
        defaultItem: {
          id: null,
          name: '',
          email: '',
          phone: '',
          reg_number: '',
          date_time: '',
          status: null,
          service_type: null,
        },
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      pickedDate () {
        this.onDateTimePicked()
      },
      pickedTime () {
        this.onDateTimePicked()
      }
    },
    created () {
  
    },
    filters: {
      clearDate: function (dt) {
        const d = dt.split('T')
        const t = d[1].split('.')
        return `${d[0]} ${t[0]}`
      }
    },
    methods: {
      getName (id, items) {
        const item = items.find(item => item.id === id)
        return item ? item.name : ''
      },
      pad2 (n) {
        return String(n).padStart(2, '0')
      },
      toRfc3339Local (dateStr, timeStr) {
        if (!dateStr || !timeStr) return ''
        const [y, m, d] = dateStr.split('-').map(Number)
        const [hh, mm] = timeStr.split(':').map(Number)
        const dt = new Date(y, m - 1, d, hh, mm, 0)
        if (Number.isNaN(dt.getTime())) return ''

        const offMin = -dt.getTimezoneOffset()
        const sign = offMin >= 0 ? '+' : '-'
        const abs = Math.abs(offMin)
        const offH = this.pad2(Math.floor(abs / 60))
        const offM = this.pad2(abs % 60)

        const yyyy = dt.getFullYear()
        const mo = this.pad2(dt.getMonth() + 1)
        const da = this.pad2(dt.getDate())
        const ho = this.pad2(dt.getHours())
        const mi = this.pad2(dt.getMinutes())
        const se = this.pad2(dt.getSeconds())
        return `${yyyy}-${mo}-${da}T${ho}:${mi}:${se}${sign}${offH}:${offM}`
      },
      parseRfc3339ToLocal (value) {
        if (!value) return { date: '', time: '' }
        const dt = new Date(String(value))
        if (Number.isNaN(dt.getTime())) return { date: '', time: '' }
        const yyyy = dt.getFullYear()
        const mo = this.pad2(dt.getMonth() + 1)
        const da = this.pad2(dt.getDate())
        const ho = this.pad2(dt.getHours())
        const mi = this.pad2(dt.getMinutes())
        return { date: `${yyyy}-${mo}-${da}`, time: `${ho}:${mi}` }
      },
      onDateTimePicked () {
        this.checkBusyError = null
        this.checkBusyResponse = null
        this.editedItem.date_time = this.toRfc3339Local(this.pickedDate, this.pickedTime)
        if (this.editedItem.date_time) {
          this.checkBusy()
        }
      },
      checkBusy () {
        if (!this.editedItem.date_time) return
        this.checkBusyLoading = true
        this.checkBusyError = null
        this.checkBusyResponse = null
        this.$store.dispatch('Bookings/CHECK', { date_time: this.editedItem.date_time })
          .then((data) => {
            this.checkBusyResponse = data
          })
          .catch((err) => {
            this.checkBusyError = err
          })
          .finally(() => {
            this.checkBusyLoading = false
          })
      },
      editItem (item) {
        this.editedIndex = this.$store.state.Bookings.list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        const parsed = this.parseRfc3339ToLocal(this.editedItem.date_time)
        this.pickedDate = parsed.date
        this.pickedTime = parsed.time
        this.dialog = true
      },
  
      deleteItem (item) {
        this.editedIndex = this.$store.state.Bookings.list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
  
      deleteItemConfirm () {
        this.$store.state.Bookings.list.splice(this.editedIndex, 1)
        this.$store.dispatch('Bookings/DELETE', this.editedItem.id)
        this.closeDelete()
      },
  
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.pickedDate = ''
          this.pickedTime = ''
          this.checkBusyLoading = false
          this.checkBusyResponse = null
          this.checkBusyError = null
          this.editedIndex = -1
        })
      },
  
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
  
      save () {
        console.log('item: ',this.editedItem)
        if (this.editedIndex > -1) {
          this.$store.dispatch('Bookings/SAVE', this.editedItem)
        } else {
          this.$store.dispatch('Bookings/NEW', this.editedItem)
        }
        this.close()
        this.editedItem = this.defaultItem
      }
    },
    mounted () {
      this.$store.dispatch('Bookings/LOAD')
    }
  }
  </script>
  
  <style lang="scss">
  
  </style>
  